import { Button, Col, Form, Input, InputPicker, Schema } from 'rsuite';
import TextField from '../../../components/form/textfield';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlexboxGrid } from 'rsuite';
import Field from '../../../components/form/field';
import TextAreaField from '../../../components/form/textarea-field';
import { faIR } from 'date-fns-jalali/locale';
import { format } from 'date-fns-jalali';
import { DatePicker } from '../../../components/form/datepicker/datepicker';
import { showToast } from '../../../utils/toast';
import { handlePostConsultantWorkBackground } from '../../../api-handler';
import { PostConsultantWorkBackgroundModel } from '../../../models';
import { getRandomId } from '../../../utils/helpers';
import { useNavigate } from 'react-router-dom';

const { StringType } = Schema.Types;
const model = Schema.Model({
  Name: StringType('').isRequired('الزامی است!'),
  Role: StringType('').isRequired('الزامی است!'),
  // Country: StringType('').isRequired('الزامی است!'),
  State: StringType('').isRequired('الزامی است!'),
  City: StringType('').isRequired('الزامی است!'),
  // Start_Date: StringType('').isRequired('الزامی است!'),
  Address: StringType('').isRequired('الزامی است!'),
  Duration: StringType('')
});
const defaultFormValue = {
  Name: '',
  Role: '',
  State: '',
  City: '',
  Address: '',
  Duration: '',
  Start_Date: new Date()
};
export const WorkBackgroundForm = (props: {
  currentWorking: boolean;
  readonly?: boolean;
  handleAddWorkData: (workData: PostConsultantWorkBackgroundModel, isCurrent: boolean) => void;
  defaultValue?: PostConsultantWorkBackgroundModel | null;
  hideNextButton?: boolean;
  forceReadOnly?: boolean;
  disabledMode?: boolean;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>(props.defaultValue ?? defaultFormValue);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [timeStamp, setTimeStamp] = useState<any>(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleSubmit = useCallback(
    async (isNext: boolean) => {
      if (formRef.current && !formRef.current.check()) {
        console.log('formError', formError);
        return;
      }
      // !start daate has problem
      if (!formValue) return;
      const payload = {
        ...formValue,
        CurrentWork: props.currentWorking,
        Start_Date: timeStamp,
        Country: 'ایران'
      };
      console.log(payload);
      if (!props.currentWorking) {
        if (!payload.Duration) {
          setFormError((pre) => {
            return { ...pre, Duration: 'الزامی است!' };
          });
          return;
        }
      }
      setLoading(true);
      const res = await handlePostConsultantWorkBackground(payload);
      setLoading(false);
      if (res.ok) {
        showToast('سوابق شغلی ثبت شد!', 'success');
        // or getting submitted data from backend
        if (isNext) {
          navigate('/consultant/education');
          return;
        }
        props.handleAddWorkData({ ...payload, RandomId: getRandomId() }, props.currentWorking);
        setFormValue(defaultFormValue);
      }
    },
    [formValue, formError, timeStamp, formRef, props.currentWorking]
  );

  useEffect(() => {
    setTimeStamp(props?.defaultValue?.Start_Date ?? new Date());
  }, [props.defaultValue]);

  return (
    <Form
      ref={formRef}
      onChange={setFormValue}
      onCheck={setFormError}
      formError={formError}
      model={model}
      onSubmit={() => handleSubmit(false)}
      formValue={formValue}
      checkTrigger="change"
      className="mt-6 text-dark"
      readOnly={props.forceReadOnly ?? loading}
      disabled={props.disabledMode}>
      <FlexboxGrid
        className={`${!props.currentWorking ? 'bg-[--rs-primary-50] rounded-md border-[1px] border-[--rs-primary-500] p-3' : null} `}>
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={16} className="max-w-[100%] !px-0">
          <FlexboxGrid>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <TextField
                name="Name"
                label={props.currentWorking ? 'نام سازمان / شرکت فعلی' : 'نام سازمان / شرکت'}
                type="string"
                accepter={Input}
                dir="rtl"
                full
                placeholder=""
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                accepter={InputPicker}
                data={[{ label: 'سمت 1', value: 'سمت 1' }]}
                name="Role"
                label="سمت / شغل"
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <div style={{ position: 'relative' }}>
                <TextField
                  className="font-fd cursor-pointer mb-4"
                  name="Start_Date"
                  type="text"
                  dir="rtl"
                  full
                  accepter={Input}
                  readOnly
                  value={format(timeStamp, 'dd MMMM yyyy', { locale: faIR })}
                  label="تاریخ شروع"
                  req
                  onClick={props.readonly ? () => null : () => setCalendarOpen((state) => !state)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: 60,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1000
                  }}>
                  <DatePicker
                    onSelectDate={setTimeStamp}
                    defaultDate={timeStamp}
                    open={calendarOpen}
                    setOpen={setCalendarOpen}
                    hideTime
                    hideToday
                    hideConfirm
                  />
                </div>
              </div>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                name="Country"
                label="کشور"
                accepter={InputPicker}
                data={[{ label: 'ایران', value: 'ایران' }]}
                dir="rtl"
                full
                defaultValue="ایران"
                disabled
                req
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                name="State"
                label="استان"
                accepter={InputPicker}
                data={[{ label: 'استان 1', value: 'استان 1' }]}
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                name="City"
                label="شهر"
                accepter={InputPicker}
                data={[{ label: 'شهر 1', value: 'شهر 1' }]}
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
          <TextAreaField
            name="Address"
            label={props.currentWorking ? 'آدرس محل کار فعلی' : 'آدرس محل کار'}
            dir="rtl"
            full
            req
            placeholder="آدرس را بدون ذکر شهر و استان نوشته و با ، جدا کنید."
            readOnly={props.readonly}
          />
        </FlexboxGrid.Item>
        {!props.currentWorking ? (
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <Field
              name="Duration"
              label="مدت سابقه"
              accepter={InputPicker}
              data={[{ label: 'مدت 1', value: 'مدت 1' }]}
              dir="rtl"
              full
              req
              readOnly={props.readonly}
            />
          </FlexboxGrid.Item>
        ) : null}
      </FlexboxGrid>

      {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
      {props.readonly || props.disabledMode ? null : (
        <>
          <div className="flex justify-between">
            <Button
              appearance="primary"
              className="ml-auto mt-4"
              type="button"
              onClick={() => handleSubmit(false)}
              loading={loading}>
              {props.hideNextButton ? 'ثبت شغل فعلی' : 'افزودن سابقه جدید'}
            </Button>
          </div>
          {props.hideNextButton ? null : (
            <div className="flex justify-between">
              <Button
                appearance="default"
                className="ml-auto mt-8"
                type="button"
                onClick={() => {
                  navigate('/consultant/personal');
                  // showToast('اطلاعات قبلا ثبت شده', 'warning');
                }}
                loading={loading}>
                مرحله قبل
              </Button>
              <Button
                appearance="primary"
                className="mr-auto mt-8"
                type="button"
                onClick={() => handleSubmit(true)}
                loading={loading}>
                ثبت و مرحله بعد
              </Button>
            </div>
          )}
        </>
      )}
    </Form>
  );
};
